import { EMPLOYMENT_LIMITATIONS } from 'cpool-constants';
import { z } from 'zod';

import { schemaEuropaceFirma } from './Firma.schema';
import { regex_iso_date } from '../../../../utils/regex.utils';
import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#angestellter

	{
		"beschaeftigungsverhaeltnis": {
			"arbeitgeber": schemaEuropaceFirma,
			"berufsbezeichnung": String,
			"befristung": "BEFRISTET" | "UNBEFRISTET",
			"befristetBis": "YYYY-MM-DD",
			"beschaeftigtSeit": "YYYY-MM-DD",
			"inProbezeit": true | false,
			"nettoeinkommenMonatlich": schemaBigDecimal
		},
		"vorherigesBeschaeftigungsverhaeltnis": {
			"arbeitgeber": schemaEuropaceFirma,
			"beschaeftigtSeit": "YYYY-MM-DD",
			"beschaeftigtBis": "YYYY-MM-DD"
		}
	}

*/
export const schemaEuropaceAngestellter = z.object({
    beschaeftigungsverhaeltnis: z.optional(
        z.object({
            arbeitgeber: z.optional(schemaEuropaceFirma),
            befristetBis: z.optional(z.string().regex(regex_iso_date)),
            befristung: z.optional(z.nativeEnum(EMPLOYMENT_LIMITATIONS)),
            berufsbezeichnung: z.optional(z.string()),
            beschaeftigtSeit: z.optional(z.string().regex(regex_iso_date)),
            inProbezeit: z.optional(z.boolean()),
            nettoeinkommenMonatlich: z.optional(schemaBigDecimal),
        }),
    ),
    vorherigesBeschaeftigungsverhaeltnis: z.optional(
        z.object({
            arbeitgeber: z.optional(schemaEuropaceFirma),
            beschaeftigtBis: z.optional(z.string().regex(regex_iso_date)),
            beschaeftigtSeit: z.optional(z.string().regex(regex_iso_date)),
        }),
    ),
});

export type SchemaEuropaceAngestellter = z.infer<typeof schemaEuropaceAngestellter>;
